import angular from 'angular';
import subcontractsComponent from './subcontracts.component';

let subcontractsModule = angular.module('subcontracts', [
])

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";
})

.component('subcontracts', subcontractsComponent);

export default subcontractsModule;



// WEBPACK FOOTER //
// ./client/pages/admin/subcontracts/subcontracts.js